import { keyMirror } from 'ramda-extension';
// typo v promenne
export default keyMirror({
    NEW_USER_ADD_ADMIN: null,
    EDIT_USER_MODAL: null,
    NEW_CYCLE_USER_SETTING: null,
    RECONNECTING_MODAL: null,
});
